import * as types from './types';
import produce from 'immer';
import * as uuid from 'uuid';

export const privacyState = {
    files: [],
    localeOptions: [],
    description: '',
    status: 'Saved'
};

const produceAddedFile = produce( ( draft, action ) => {
    draft.files.push( {
        file: action.file,
        name: action.name,
        locale: '',
        key: uuid()
    } );
} );

const produceSetPrivacy = produce( ( draft, action ) => {
    draft.description = action.privacy.description;
    draft.status = action.privacy.status;
    draft.files = action.privacy.files.map( file => ( { ...file, key: uuid() } ) );
} );

const produceLocaleOptions = produce( ( draft, action ) => {
    draft.localeOptions = action.options;
} );

const produceSetLocale = produce( ( draft, action ) => {
    const index = draft.files.findIndex( file => file.key === action.key );
    draft.files[ index ].locale = action.locale;
} );

const produceRemovedFile = produce( ( draft, action ) => {
    draft.files = draft.files.filter( file => file.key !== action.key );
} );

const produceSetPrivacyValue = produce( ( draft, action ) => {
    draft[ action.name ] = action.value;
} );

export const privacyReducer = ( state = privacyState, action ) => {
    switch ( action.type ) {
        case types.PRIVACY__SET_PRIVACY:
            return produceSetPrivacy( state, action );
        case types.PRIVACY__ADD_FILE:
            return produceAddedFile( state, action );
        case types.PRIVACY__SET_LOCALE_OPTIONS:
            return produceLocaleOptions( state, action );
        case types.PRIVACY__SET_FILE_LOCALE:
            return produceSetLocale( state, action );
        case types.PRIVACY__REMOVE_FILE:
            return produceRemovedFile( state, action );
        case types.PRIVACY__SET_PRIVACY_VALUE:
            return produceSetPrivacyValue( state, action );
        case types.PRIVACY__CLEAR_PRIVACY:
            return privacyState;
        default:
            return state;
    }
};
